import { render } from "./CoverPage.vue?vue&type=template&id=17560e63&scoped=true&ts=true"
import script from "./CoverPage.vue?vue&type=script&lang=ts"
export * from "./CoverPage.vue?vue&type=script&lang=ts"

import "./CoverPage.vue?vue&type=style&index=0&id=17560e63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17560e63"]])

export default __exports__